import styled from "styled-components";

interface iIsOpenSideMenu {
  isOpen?: boolean;
}

export const FilterFooter = styled.footer<iIsOpenSideMenu>`
  display: flex;
  justify-content: center;
  align-items: center;
  border-top: 1px solid ${(props) => props.theme.colors.neutral2.light};

  width: 100%;
  margin: auto;

  @media (min-width: 480px) {
    padding: 40px;
  }

  @media (max-width: 768px) {
    position: ${(props) => (props.isOpen ? `fixed` : "")};
    background-color: rgb(33, 33, 33);
    padding: 40px 28px;
    bottom: 0;
    left: 0;
    right: 0;
  }

  @media (min-width: 768px) {
    border: none;
    padding: 0 30px 30px 0;
    display: flex;
    justify-content: flex-end;
  }

  .filter-button {
    font-size: 0.75rem;
    border: 1px solid ${(props) => props.theme.colors.neutral2.light};
    border-radius: 100px;
    height: 56px;
    color: #ffffff;
  }

  .first {
    margin-bottom: 14px;
    color: #424242;
    background-color: #dbc7b8;
  }

  > div {
    display: flex;
    flex-direction: column-reverse;
    width: 100%;

    @media (min-width: 768px) {
      flex-direction: row-reverse;
      gap: 16px;
      width: 304px;
      display: flex;
    }
  }
`;
